import { Box } from "@twilio-paste/core/box";
import { Heading, HeadingProps } from "@twilio-paste/core/heading";
import { styled, themeGet } from "@twilio-paste/styling-library";
import React from "react";
import { slugify } from "../../../utils/stringUtils";

const StyledAnchorHyperlink = styled.a`
    text-decoration: none;
    margin-left: ${themeGet("space.space30")};
    color: ${themeGet("textColors.colorTextWeak")};

    &:hover {
        text-decoration: underline;
    }
`;

const HeadingContainer = styled(Box)`
    scroll-margin-top: 80px;
`;

const AnchoredHeading: React.FC<HeadingProps> = (props) => {
    // Only generate slugs for headings where children is 'string'
    let anchor = props.id;
    if (typeof props.children === "string") {
        anchor = slugify(props.children);
    }

    return (
        /** We could add the id on the Heading element itself,
         * but we also want some custom styles , mainly `scroll-margin-top` ,
         * to make sure that internal links open correctly, accounting for the fixed page header ,
         * thus we've added this extra div here. */
        <HeadingContainer id={anchor}>
            <Heading {...props} style={{ overflow: "auto" }}>
                {props.children}
                {anchor && <StyledAnchorHyperlink href={`#${anchor}`}>#</StyledAnchorHyperlink>}
            </Heading>
        </HeadingContainer>
    );
};

export { AnchoredHeading };
